/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnectionRetailerSalesTypes from './receive-connection-retailer-sales-types';

export default (connectionId) => (dispatch) => {
    dispatch({
        type: actions.CONNECTION_RETAILER_SALES_TYPES_REQUEST,
    });

    return cecSdk
        .connectionRetailerSalesTypes(connectionId)
        .getConnectionRetailerSalesTypes()
        .then((retailerSalesTypes) => {
            dispatch({
                type: actions.CONNECTION_RETAILER_SALES_TYPES_REQUEST_SUCCESS,
            });
            
            dispatch(receiveConnectionRetailerSalesTypes(retailerSalesTypes));
            return retailerSalesTypes;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTION_RETAILER_SALES_TYPES_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
